/** Literal recognition only. No parser, evaluator or prototype function is invoked. */
export function prototypeTone(value:string):{operand:string;negative:string;positive:string}|undefined{
 if(value.length>512)return;
 const matches=[...value.matchAll(/\$\{\s*([A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*){1,3})\s*<\s*0\s*\?\s*['"]([A-Za-z0-9_-]{1,64})['"]\s*:\s*['"]([A-Za-z0-9_-]{1,64})['"]\s*\}/g)];
 if(matches.length!==1)return;
 return {operand:matches[0][1],negative:matches[0][2],positive:matches[0][3]};
}
